import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentSubNav: "yzd",
    gameInfo: null,
    userInfo: null,
    user: null,
  },
  mutations: {},
  actions: {},
});
